export type PregnancySelection =
  | { kind: "existing"; pregnancyId: string }
  | {
      kind: "new"
      estimatedDateOfDelivery?: string
      deliveryDate?: string
      patientOptedInClinically: boolean
    }

export const newPregnancyDefault: PregnancySelection = {
  kind: "new",
  estimatedDateOfDelivery: "",
  deliveryDate: "",
  patientOptedInClinically: true,
}

export const initialPregnancySelection = ({
  pregnancyId,
  hasExistingPregnancies,
}: {
  pregnancyId: string | undefined
  hasExistingPregnancies: boolean
}): PregnancySelection => {
  if (pregnancyId) return { kind: "existing", pregnancyId }
  if (hasExistingPregnancies) return { kind: "existing", pregnancyId: "" }
  return newPregnancyDefault
}
